/*
 * View for the status selector for topics
 */

define([
  "marionette",
  "modules/topicsSplit/topic/topicStatus/template/topicStatusTemplate.html",
  "modules/topicsSplit/topic/topicStatus/template/topicStatusItemTemplate.html",
], function (Marionette, TopicStatusTemplate, TopicStatusItemTemplate) {
  var TopicStatusView = {};

  TopicStatusView.topicStatusView = Marionette.ItemView.extend({
    template: TopicStatusItemTemplate,
    tagName: "li",
    triggers: {
      click: "select:status",
    },
  });

  TopicStatusView.topicStatusesView = Marionette.CompositeView.extend({
    template: TopicStatusTemplate,
    itemView: TopicStatusView.topicStatusView,
    itemViewContainer: "ul",
    modelEvents: {
      sync: "render",
      change: "render",
    },
  });

  return TopicStatusView;
});
